import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Profile from './pages/Profile';
import Instagram from './pages/Instagram';
import Contact from './pages/Contact';
import PastAds from './pages/PastAds';
import Gallery from './pages/Gallery';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

// Scroll Restoration Component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Instant scroll to top on route change
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-[#0a0a0a] text-white antialiased selection:bg-brand-oak/20 selection:text-white">
        <ScrollToTop />
        
        {/* Header Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produkter" element={<Products />} />
            <Route path="/produkter/:slug" element={<ProductDetail />} />
            <Route path="/profil" element={<Profile />} />
            <Route path="/instagram" element={<Instagram />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/tidligere-annoncer" element={<PastAds />} />
            <Route path="/galleri" element={<Gallery />} />
            <Route path="/galleri/:slug" element={<Gallery />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
